const RectangleShape = ({ shapeId, elementProperties = {} }) => {

  const {
    isTransparent,
    strokeWidth,
    backgroundColor,
    borderColor,
    strokeUnit,
    opacity = 100,
  } = elementProperties;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      id={shapeId}
      style={{ opacity: opacity / 100 }}
    >
      <rect
        id={shapeId}
        x="2"
        y="2"
        width="96"
        height="96"
        fill={isTransparent ? "none" : backgroundColor}
        stroke={borderColor}
        strokeWidth={`${strokeWidth}${strokeUnit}`}
      />
    </svg>
  );
};

export default RectangleShape;